import moment from 'moment'

import {
  CostCenterAssignment,
  FormattedAssignment,
} from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

interface Props {
  currentAssignments: FormattedAssignment[]
  allAssignments: CostCenterAssignment[]
  isCurrentActive: boolean
  startDate?: string
}

export const canBeMarkedAsActive = ({
  currentAssignments,
  allAssignments,
  isCurrentActive,
  startDate,
}: Props) => {
  const startDateMoment = moment(startDate)

  const hasNotAssignments = allAssignments.length <= 1

  const hasNotPreviousAssignment = allAssignments
    .filter((assignment) => assignment.id !== String(currentAssignments[0]?.id))
    .every((assignment) => {
      return startDateMoment.isAfter(moment(assignment.startDate), 'day')
    })

  return hasNotAssignments || hasNotPreviousAssignment || isCurrentActive
}
